import { useEffect, useRef } from "react";
import colonoscopyFlyer from "../../assets/colonoscopy_flyer.jpg";

export default function ClinicalTrial() {
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add("visible")),
      { threshold: 0.1 }
    );
    const items = ref.current?.querySelectorAll(".animate-on-view");
    items?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="clinical-trial"
      data-testid="clinical-trial-section"
      className="ez-section bg-white"
      ref={ref}
    >
      <div className="ez-container">
        <div className="animate-on-view flex flex-col lg:flex-row items-center gap-12 lg:gap-16">

          {/* LEFT — Text content */}
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-block text-ez-teal font-semibold font-caveat text-lg mb-3">
              Featured Opportunity
            </div>
            <h2 className="font-outfit text-2xl md:text-3xl font-bold text-ez-text mb-4">
              Clinical <span className="text-ez-teal">Trial</span>
            </h2>
            <p className="text-ez-muted font-jakarta text-lg leading-relaxed mb-6">
              EZ Care Pharmacy is proud to connect our community with health research opportunities.
            </p>
            <p className="text-ez-muted font-jakarta leading-relaxed mb-8">
              Are you planning on a colonoscopy? Join our featured clinical study and help develop a new test for the early detection of colon cancer — and earn <span className="font-semibold text-ez-text">$325–$475</span> in electronic payment card compensation for your time.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <a
                href="tel:+18625201063"
                className="ez-btn-primary text-sm py-3 px-6"
              >
                Call to Learn More
              </a>
              <a
                href="https://wa.me/12016742138?text=Hi%20EZ%20Care%20Pharmacy!%20I%20would%20like%20to%20learn%20more%20about%20the%20clinical%20trial."
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 border border-ez-teal text-ez-teal hover:bg-ez-teal hover:text-white transition-all duration-200 py-3 px-6 rounded-full text-sm font-semibold"
              >
                WhatsApp Us
              </a>
            </div>
          </div>

          {/* RIGHT — Flyer image */}
          <div className="animate-on-view flex-1 w-full" style={{ transitionDelay: "0.15s" }}>
            <div className="rounded-3xl overflow-hidden shadow-2xl border border-gray-100">
              <img
                src={colonoscopyFlyer}
                alt="Planning on a Colonoscopy? Featured Trial — Now Recruiting"
                className="w-full h-auto object-contain"
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
